import { RootState } from '@/app/rootReducer';
import { createSelector } from 'reselect';

export const getSwitchesByAgentId = (agentId: number) =>
  createSelector(
    (state: RootState) => state.agentSwitchesState.switchesById,
    (switchesById) =>
      Object.values(switchesById).filter((item) => item.agent_id === agentId)
  );
